import "./InfoModal.css";

function InfoModal({ title, text, onClose }) {
  return (
    <div className="info-overlay" onClick={onClose}>
      <div 
        className="info-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="info-header">
          <h3>{title}</h3>
          <button className="info-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <p className="info-text">{text}</p>

        <div className="info-footer">
          <button onClick={onClose}>Got it</button>
        </div>
      </div>
    </div>
  );
}

export default InfoModal;